import React, { useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MySwal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { COLOR_INFO } from "../../../Colors";

const swal = withReactContent(MySwal);

const ComentariosCell = ({ value, explicacao, ...props }) => {
  const handleExplanationModal = useCallback(() => {
    swal.fire({
      type: "info",
      html: (
        <div>
          <h4>Explicação</h4>
          <br />
          {explicacao.split("\n").map((paragraph) => !paragraph ? (
            <br />
          ) : (
            <p key={paragraph}>{paragraph}</p>
          )
          )}
        </div>
      ),
    });
  }, [explicacao]);

  return (
    <div className="flex-grow-1">
      {value}
      <span className="d-inline-block d-md-none pl-2">
        Comentário(s)
      </span>
      <button
        className="a ml-4"
        title="Ver"
        {...props}
      >
        <FontAwesomeIcon icon="envelope" />
      </button>
      {!!explicacao && (
        <button
          className="a ml-2"
          title="Explicação"
          onClick={handleExplanationModal}
          style={{ color: COLOR_INFO }}
        >
          <FontAwesomeIcon icon="question-circle" />
        </button>
      )}
    </div>
  )
}

export default ComentariosCell;
